<h4 class="font-6 fw-semibold mb-2">
    <ng-content></ng-content>
</h4>